import { Country } from './country';
import { Payout_Gateway_Enum } from './portal';
import { ContactItem } from '../components/user-dashboard/contacts/models/contacts';
import { OfferItem } from '../components/user-dashboard/offer/models/offer';

export class StandardPagination {
  currentPage?: number;
  countInCurrentPage?: number;
  totalItems?: number;
  totalPages?: number;
  maxPreviousPage?: number;
  maxNextPage?: number;
}

export class PeriodBasedObject {
  period?: PeriodTypeValue;
  unit?: string;
}

export class PeriodTypeValue {
  public startDate: number;
  public endDate: number;
}

export class AvatarResult {
  big: string;
  medium: string;
  small: string;
}

export class ChartValue {
  name: string;
  time: number;
  value: number;
}

export class CommissionsModel {
  public lev1: number;
  public lev2?: number;
  public vip?: number;
}

export enum AffiliatesInvitationStatusEnum {
  pending = 'invited',
  joined = 'joined',
  rejected = 'rejected',
  blocked = 'blocked',
}

export enum AffiliateLinkStatusEnum {
  active = 'active',
  inactive = 'inactive',
  suspended = 'suspended',
}

export class AffiliateMinimizedModel {
  public id: number;
  public firstName: string;
  public lastName: string;
  public email: string;
  public note?: string;
  public status?: AffiliatesInvitationStatusEnum;
  public image?: any; // AvatarResult | string
  public avatar?: AvatarResult;
  public affiliateLinks?: AffiliateLinkMinimizedModel[];
  public isVip?: boolean;
  public delete?: boolean;
  public image_id?: number[];
  public invitedAt?: number;
  public joinedAt?: number;
  public preferredPaymentMethod?: Payout_Gateway_Enum[];
  public messengerThreadId?: number;
  public unreadMessagesCount?: number;
}

export class AffiliateLinkMinimizedModel {
  public id?: number;
  public name: string;
  public link?: string;
  public offer?: OfferItem;
  public offerId?: number;
  public vipAffiliate?: AffiliateMinimizedModel;
  public affiliates?: AffiliateMinimizedModel[];
  public vipEmail?: string;
  public affiliateEmails?: string[];
  public image?: string;
  public type: 'general' | 'vip';
  public visibility?: 'public' | 'private';
  public commissions: CommissionsModel;
  public affiliateCount: number;
  public clicks?: number;
  public conversion?: number;
  public conversionRate?: number;
  public isVip?: boolean;
  public stats: { sales: number; revenue: number; commissions: number };
  public status: AffiliateLinkStatusEnum;
  public updatedAt?: number;
  public createdAt?: number;
}

export enum AffiliateNotificationTypeEnum {
  invitation = 'invitation',
  new_sale = 'new_sale',
  commission_processed = 'commission_processed',
  affiliate_link_add = 'affiliate_link_add',
  affiliate_link_update = 'affiliate_link_update',
  affiliate_link_paused = 'affiliate_link_paused',
  affiliate_link_resumed = 'affiliate_link_resumed',
  refund = 'refund',
  general = 'general',
}

export enum OwnerNotificationTypeEnum {
  invitation_accepted = 'invitation_accepted',
  invitation_rejected = 'invitation_rejected',
  invitation_blocked = 'invitation_blocked',
  general = 'general',
  new_sale = 'new_sale',
  refund = 'refund',
  payout_critical = 'payout_critical',
  payout_due = 'payout_due',
  new_comment = 'new_comment',
  comment_reply = 'comment_reply',
}

export enum NotificationStatusEnum {
  read = 'read',
  unread = 'unread',
}

export class NotificationElement {
  public id: number;
  public content: string;
  public type: AffiliateNotificationTypeEnum | OwnerNotificationTypeEnum;
  public status: NotificationStatusEnum;
  public image?: string;
  public createdAt?: number;
  public notificationUserType: NotificationUserType;
  public target: NotificationTarget;
}

export enum NotificationUserType {
  AFFILIATE = 'affiliate',
  OWNER = 'owner',
}

export class NotificationTarget {
  label: string;
  ownerId?: number;
  affiliateId?: number;
  affiliateLinkId?: number;
  announcementId?: number;
  announcementTitle?: string;
  periodId?: number;
  refundId?: number;
  saleId?: number;
  targetUrl?: string;
  courseId?: number;
  commentId?: number;
  productId?: number;
  itemId?: string;
  itemType?: string;
}

export class CustomerObject extends ContactItem {}

export class CustomerDetailedObject extends CustomerObject {
  country: Country;
  browser: BrowserNameEnum;
  os: OperatingSystemEnum;
  device: DeviceTypeEnum;
}

export enum BrowserNameEnum {
  Chrome = 'Chrome',
  Edge = 'Edge',
  Opera = 'Opera',
  Firefox = 'Firefox',
  Safari = 'Safari',
  InternetExplorer = 'Internet Explorer',
  Yandex = 'Yandex',
  UCBrowser = 'UC Browser',
  WeChat = 'WeChat',
  QQBrowser = 'QQ Browser',
  CocCoc = 'Coc Coc',
  Dolphin = 'Dolphin',
  MIUIBrowser = 'MIUI Browser',
  Tesla = 'Tesla',
  Browser360 = '360 Browser',
  AvastAVG = 'Avast/AVG Secure Browser',
  FirefoxFocus = 'Firefox Focus',
  OperaTouch = 'Opera Touch',
  Kindle = 'Kindle',
  LunascapeMaxthon = 'Lunascape/Maxthon',
  TridentBased = 'Trident-based Browser',
  WebkitKHTMLBased = 'Webkit/KHTML-based Browser',
  Electron = 'Electron-based App',
  TikTok = 'TikTok',
  ChromeHeadless = 'Chrome Headless',
  ChromeWebView = 'Chrome WebView',
  AndroidBrowser = 'Android Browser',
  MobileSafari = 'Mobile Safari',
  unrecognized = 'Unrecognized',
}

export enum OperatingSystemEnum {
  Windows = 'Windows',
  WindowsPhone = 'Windows Phone',
  MacOS = 'Mac OS',
  iOS = 'iOS',
  Android = 'Android',
  Kindle = 'Kindle',
  Linux = 'Linux',
  Tizen = 'Tizen',
  Sailfish = 'Sailfish',
  Huawei = 'Huawei',
  Oculus = 'Oculus',
  Samsung = 'Samsung',
  FirefoxOS = 'Firefox OS',
  ChromeOS = 'Chrome OS',
  unrecognized = 'Unrecognized',
}

export enum DeviceTypeEnum {
  computer = 'Computer',
  watch = 'Watch',
  phone = 'Phone',
  device = 'Device',
  unrecognized = 'Unrecognized',
}
